import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUsers,
  faCalendarCheck,
  faFileInvoice,
  faUserTie,
  faFolderOpen,
  faClipboardList,
  faChartLine,
  faRobot,
  faEnvelope
} from '@fortawesome/free-solid-svg-icons';

interface Feature {
  icon: any;
  title: string;
  description: string;
}

const features: Feature[] = [
  {
    icon: faUsers,
    title: 'Customer Management',
    description: 'Track leads, customers, and opportunities in one place so your team always knows the next revenue-driving action.'
  },
  {
    icon: faCalendarCheck,
    title: 'Appointment Scheduling',
    description: 'Easily create and manage appointments while keeping your team\'s schedule organized.'
  },
  {
    icon: faEnvelope,
    title: 'Lead Funnel Automation',
    description: 'Capture inbound leads and move them through structured follow-up funnels that increase conversion and reduce no-shows.'
  },
  {
    icon: faFileInvoice,
    title: 'Revenue Pipeline',
    description: 'Automate quote-to-cash workflows from estimate to invoice to payment so deals close faster and cash flow improves.'
  },
  {
    icon: faUserTie,
    title: 'Employee Management',
    description: 'Track employee hours, assignments, and performance all in one dashboard.'
  },
  {
    icon: faFolderOpen,
    title: 'Custom Integrations',
    description: 'Connect your CRM with forms, ads, email, SMS, calendars, and other tools to create one connected revenue engine.'
  },
  {
    icon: faClipboardList,
    title: 'Task Management',
    description: 'Create, assign, and track tasks to ensure nothing falls through the cracks.'
  },
  {
    icon: faChartLine,
    title: 'Pipeline Analytics',
    description: 'See exactly where leads are dropping off and where revenue is won so you can optimize your funnel with confidence.'
  },
  {
    icon: faRobot,
    title: 'Custom AI Automation',
    description: 'Deploy AI-powered lead response, sales follow-up, and admin automations tailored to your exact workflow.'
  }
];

const Features: React.FC = () => {
  return (
    <section id="features" className="features-section-modern">
      <Container>
        <Row className="mb-5">
          <Col lg={8} className="mx-auto text-center">
            <h2 className="section-title mb-3">
              Built to drive revenue
            </h2>
            <p className="section-subtitle">
              CRM, custom integrations, and sales automation pipelines designed to convert more leads into paying customers
            </p>
          </Col>
        </Row>

        <Row className="g-4">
          {features.map((feature, index) => (
            <Col key={index} lg={3} md={6}>
              <div className="feature-card-modern">
                <div className="feature-icon-modern mb-3">
                  <FontAwesomeIcon icon={feature.icon} />
                </div>
                <h5 className="feature-title-modern mb-2">{feature.title}</h5>
                <p className="feature-description-modern">{feature.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Features;
